<template>
  <div class="gestione-strutture" v-if="!isFetching">
    <h3 style="float: left">{{ labels.gestione_strutture }}</h3>
    <b-button
      variant="success"
      style="float: right"
      @click="crea_nuova_struttura"
      >{{ labels.crea_nuova_struttura }}</b-button
    >
    <b-table
      responsive
      striped
      hover
      :items="strutture"
      :fields="colonne_strutture"
    >
      <template v-slot:cell(codice)="data">
        <!-- `data.value` is the value after formatted by the Formatter -->
        <b-link v-on:click="modifica_struttura(data)">{{ data.value }}</b-link>
      </template>
      <template v-slot:cell(pulsanti)="data">
        <div style="text-align: right">
          <b-button
            style="margin-right: 5px"
            variant="success"
            size="sm"
            @click="elimina_struttura(data)"
            :disabled="invio_in_corso"
            >{{ labels.elimina_struttura }}</b-button
          >
          <b-button
            variant="success"
            size="sm"
            @click="modifica_struttura(data)"
            >{{ labels.modifica_struttura }}</b-button
          >
        </div>
      </template>
    </b-table>

    <!--
    <b-alert
      :show="dismissCountDown"
      dismissible
      fade
      variant="warning"
      @dismiss-count-down="countDownChanged"
    >{{ labels.eliminazione_effettuata }}</b-alert>
    -->
  </div>
</template>

<script>
import store from "@/store/index";
import router from "@/router/index";
const axios = require("axios");

export default {
  name: "GestioneStrutture",
  data() {
    return {
      labels: {},
      labels_errori: {},
      size: "sm",
      strutture: [],
      colonne_strutture: [],
      isFetching: true,
      invio_in_corso: false,
    };
  },
  components: {},

  props: {},
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },
  methods: {
    crea_nuova_struttura() {
      try {
        this.$router.push({
          name: "ModificaStruttura",
          params: {
            struttura: "",
          },
        });
      } catch (error) {
        this.registraErrore(error, "GestioneStrutture-crea_nuova_struttura");
      }
    },
    modifica_struttura(struttura) {
      try {
        this.$router.push({
          name: "ModificaStruttura",
          params: {
            struttura: struttura.item.codice,
          },
        });
      } catch (error) {
        this.registraErrore(error, "GestioneStrutture-modifica_struttura");
      }
    },
    elimina_struttura(struttura) {
      this.$bvModal
        .msgBoxConfirm(
          this.labels.confermi_eliminazione +
            ": " +
            struttura.item.codice +
            " ?",
          {
            title: this.labels.conferma_eliminazione,
            size: "md",
            buttonSize: "sm",
            okVariant: "success",
            okTitle: "OK",
            cancelVariant: "warning",
            cancelTitle: "Annulla",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            let me = this;

            let parametri = {
              utente_collegato: this.$store.state.Utente,
              password_utente_collegato: this.$store.state.Password,
              struttura: struttura.item.codice,
            };

            let ServerURL = this.$store.state.ServerURL;
            let parametri_json = JSON.stringify(parametri);

            fn_CambiaCursore("wait", this);
            this.invio_in_corso = true;

            axios({
              method: "post",
              url: ServerURL + "CheckIn/EliminaStruttura",
              data: parametri_json,
            })
              .then(function (response) {
                me.invio_in_corso = false;
                fn_CambiaCursore("default", me);
                if (response.data.errore == 0) {
                  me.$root.$children[0].$refs.ApplicationAlert.show(
                    me.labels.eliminazione_effettuata
                  );
                  me.strutture.splice(struttura.index, 1);
                } else if (response.data.errore == -2) {
                  me.registraErrore(
                    response.data.esito,
                    "GestioneStrutture-elimina_struttura"
                  );
                } else {
                  me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
                    title: me.labels_errori.si_e_verificato_un_errore,
                    bodyClass: "errore",
                  });
                }
              })
              .catch(function (error) {
                me.invio_in_corso = false;
                fn_CambiaCursore("default", me);
                me.registraErrore(error, "GestioneStrutture-elimina_struttura");
              });
          }
        })
        .catch((error) => {
          this.invio_in_corso = false;
          this.registraErrore(error, "GestioneStrutture-elimina_struttura");
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    try {
      let UtenteAutenticato = store.state.UtenteAutenticato;
      let UtentePartner = store.state.UtentePartner;
      if (
        (to.meta.requiresAuth && !UtenteAutenticato) ||
        (to.meta.is_partner && !UtentePartner)
      ) {
        router.push("/menupartner/permessiinsufficienti", null, function () {});
      } else {
        next();
      }
    } catch (error) {
      router.push({ name: "Errore", params: { errore: error.stack } });
    }
  },
  created() {
    try {
      let me = this;

      fn_CambiaLingua(this.$store.state.Lingua, this);

      let ServerURL = this.$store.state.ServerURL;

      let parametri = {
        utente_collegato: this.$store.state.Utente,
        password_utente_collegato: this.$store.state.Password,
        partner: this.$store.state.Utente,
      };

      let parametri_json = JSON.stringify(parametri);
      fn_CambiaCursore("wait", this);

      axios({
        method: "post",
        url: ServerURL + "CheckIn/LeggiStrutture",
        data: parametri_json,
      })
        .then(function (response) {
          fn_CambiaCursore("default", me);
          me.strutture = response.data.oggetto;
          me.isFetching = false;
        })
        .catch(function (error) {
          fn_CambiaCursore("default", me);
          me.registraErrore(error, "GestioneStrutture-created");
        });
    } catch (error) {
      this.registraErrore(error, "GestioneStrutture-created");
    }
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {
      gestione_strutture: "Gestione strutture",
      crea_nuova_struttura: "Crea nuova struttura",
      elimina_struttura: "Elimina",
      modifica_struttura: "Modifica",
      codice: "Codice",
      descrizione: "Descrizione",
      email: "Email",
      telefono: "Telefono",
      confermi_eliminazione: "Confermi l'eliminazione della struttura",
      conferma_eliminazione: "Conferma eliminazione",
      eliminazione_effettuata: "Eliminazione effettuata",
    };
    let labels_inglese = {
      gestione_strutture: "Gestione strutture",
      crea_nuova_struttura: "Crea nuova struttura",
      elimina_struttura: "Elimina",
      modifica_struttura: "Modifica",
      codice: "Codice",
      descrizione: "Descrizione",
      email: "Email",
      telefono: "Telefono",
      confermi_eliminazione: "Confermi l'eliminazione della struttura",
      conferma_eliminazione: "Conferma eliminazione",
      eliminazione_effettuata: "Eliminazione effettuata",
    };
    let labels_tedesco = {
      gestione_strutture: "Gestione strutture",
      crea_nuova_struttura: "Crea nuova struttura",
      elimina_struttura: "Elimina",
      modifica_struttura: "Modifica",
      codice: "Codice",
      descrizione: "Descrizione",
      email: "Email",
      telefono: "Telefono",
      confermi_eliminazione: "Confermi l'eliminazione della struttura",
      conferma_eliminazione: "Conferma eliminazione",
      eliminazione_effettuata: "Eliminazione effettuata",
    };
    let labels_francese = {
      gestione_strutture: "Gestione strutture",
      crea_nuova_struttura: "Crea nuova struttura",
      elimina_struttura: "Elimina",
      modifica_struttura: "Modifica",
      codice: "Codice",
      descrizione: "Descrizione",
      email: "Email",
      telefono: "Telefono",
      confermi_eliminazione: "Confermi l'eliminazione della struttura",
      conferma_eliminazione: "Conferma eliminazione",
      eliminazione_effettuata: "Eliminazione effettuata",
    };

    let labels_errori_italiano = {
      struttura_con_checkin:
        "Alla struttura sono collegati dati di check-in. Eliminazione non consentita. In alternativa, la struttura può essere disabilitata.",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_inglese = {
      struttura_con_checkin:
        "Alla struttura sono collegati dati di check-in. Eliminazione non consentita. In alternativa, la struttura può essere disabilitata.",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_tedesco = {
      struttura_con_checkin:
        "Alla struttura sono collegati dati di check-in. Eliminazione non consentita. In alternativa, la struttura può essere disabilitata.",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_francese = {
      struttura_con_checkin:
        "Alla struttura sono collegati dati di check-in. Eliminazione non consentita. In alternativa, la struttura può essere disabilitata.",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }

    vm.colonne_strutture.splice(0);
    vm.colonne_strutture.push({ key: "codice", label: vm.labels.codice });
    vm.colonne_strutture.push({
      key: "descrizione",
      label: vm.labels.descrizione,
    });
    vm.colonne_strutture.push({ key: "email", label: vm.labels.email });
    vm.colonne_strutture.push({ key: "telefono", label: vm.labels.telefono });
    vm.colonne_strutture.push({
      key: "disabilitata",
      label: vm.labels.disabilitata,
    });
    vm.colonne_strutture.push({ key: "pulsanti", label: "" });
  } catch (error) {
    vm.registraErrore(error, "GestioneStrutture-fn_CambiaLingua");
  }
}
function fn_CambiaCursore(cursore, vm) {
  document.querySelector("body").style.cursor = cursore;

  if (cursore == "wait") {
    vm.invio_in_corso = true;
  } else {
    vm.invio_in_corso = false;
  }
}
</script>
<style scoped>
.gestione-strutture {
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
  border-radius: 4px;
  padding: 20px;
}
</style>
